// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "flight-3LMqI";
var _4 = "price__total-2tNzm";
var _5 = "price-3cqwe";
var _6 = "timelimit-31aU0";
var _7 = "wrapper-UEief";
var _8 = "view-3UBFI";
var _9 = "details-6x0Js";
export { _1 as "__esModule", _2 as "mobile", _3 as "flight", _4 as "price__total", _5 as "price", _6 as "timelimit", _7 as "wrapper", _8 as "view", _9 as "details" }
export default { "__esModule": _1, "mobile": _2, "flight": _3, "price__total": _4, "price": _5, "timelimit": _6, "wrapper": _7, "view": _8, "details": _9 }
